import { AnimatePresence, motion } from 'framer-motion';
import Icon from './Icon';
import { Field } from './UI';
import { inr, lakhLabel } from '../utils/format';

const VISIBILITY = [
  { value: 'all', label: 'Everyone', icon: 'globe' },
  { value: 'premium', label: 'Premium only', icon: 'crown' },
  { value: 'hidden', label: 'Only me', icon: 'lock' },
];

// Lets a member reuse their MedHire salary, enter a different one, and choose who sees it.
export default function IncomeChooser({ value = {}, onChange, medhireSalary }) {
  const medhireAmount = medhireSalary?.present || medhireSalary?.expected;
  const source = medhireAmount ? value.source || 'medhire' : 'custom';
  const set = (patch) => onChange({ ...value, source, ...patch });

  return (
    <div className="income">
      {medhireAmount && (
        <div className="income__choices">
          <motion.button
            type="button"
            whileTap={{ scale: 0.98 }}
            className={`choice ${source === 'medhire' ? 'is-active' : ''}`}
            onClick={() => set({ source: 'medhire', amount: medhireAmount, period: 'monthly' })}
          >
            <span className="choice__radio" />
            <span>
              <strong>Same as MedHire</strong>
              <small>
                {inr(medhireAmount)} / month · {lakhLabel(medhireAmount, 'monthly')}
                {!medhireSalary.present && ' (expected)'}
              </small>
            </span>
            <span className="medhire-chip"><Icon name="steth" size={12} /> MedHire</span>
          </motion.button>
          <motion.button
            type="button"
            whileTap={{ scale: 0.98 }}
            className={`choice ${source === 'custom' ? 'is-active' : ''}`}
            onClick={() => set({ source: 'custom', amount: value.source === 'custom' ? value.amount : '', period: value.period || 'yearly' })}
          >
            <span className="choice__radio" />
            <span>
              <strong>Show a different amount</strong>
              <small>Enter what you'd like matches to see</small>
            </span>
          </motion.button>
        </div>
      )}

      <AnimatePresence initial={false}>
        {source === 'custom' && (
          <motion.div className="income__custom" initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }}>
            <div className="row-2">
              <Field label="Amount (₹)">
                <input className="input" type="number" min="0" placeholder="e.g. 1500000" value={value.amount || ''} onChange={(e) => set({ amount: e.target.value })} />
              </Field>
              <Field label="Per">
                <div className="seg">
                  {['monthly', 'yearly'].map((p) => (
                    <button type="button" key={p} className={(value.period || 'yearly') === p ? 'is-active' : ''} onClick={() => set({ period: p })}>
                      {p === 'monthly' ? 'Month' : 'Year'}
                    </button>
                  ))}
                </div>
              </Field>
            </div>
            {value.amount > 0 && <p className="field__hint">Shown as {lakhLabel(Number(value.amount), value.period || 'yearly')}</p>}
          </motion.div>
        )}
      </AnimatePresence>

      <Field label="Who can see my income?">
        <div className="seg seg--icons">
          {VISIBILITY.map((v) => (
            <button type="button" key={v.value} className={(value.visibility || 'all') === v.value ? 'is-active' : ''} onClick={() => set({ visibility: v.value })}>
              <Icon name={v.icon} size={15} /> {v.label}
            </button>
          ))}
        </div>
      </Field>
    </div>
  );
}
